import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { greyScaleColors, semanticColors } from '../../../Globals/styles'
import { absenceCodes } from '../../../Globals/constants'
import DatepickerSmall from '../../../Common/datepickerSmall'
import { dates } from '../../../Util/dateTime'

class AbsenceStep extends Component {
  onDateChange = (val) => {
    const { initValue, handleConflict, index } = this.props;
    let result = {...initValue}
    result.date = val;
    handleConflict(result, index);
  };
  onAbsenceCodeChosen = (val) => {
    const { initValue, handleConflict, index } = this.props;
    let result = {...initValue}
    result.absenceCode = val;
    handleConflict(result, index);
  };
  isRegistrationDateBeforeToday = () => {
    //comparing the two dates with hours, seconds, miliseconds set to 0
    return dates.compare(new Date(this.props.registrationDate).setHours(0,0,0,0), new Date().setHours(0,0,0,0))
  };
  render () {
    const { employee, initValue } = this.props;
    var absenceCodeNodes = Object.keys(absenceCodes).map((key) => {
      return (
        <button
          className="btn btn-default waves-btn"
          key={key}
          onClick={() => this.onAbsenceCodeChosen(key)}
          style={[styles.absenceCode, initValue.absenceCode===key && styles.absenceCodeActive]}>
          {absenceCodes[key]}
        </button>
        )
    })
    return (
      <div>
        <div style={styles.header}>
          <h2 style={styles.heading}>Fravær <span style={styles.employeeName}>- {employee.name}</span></h2>
        </div>
        <div style={styles.leftContainer}>
          {absenceCodeNodes}
        </div>
        <div style={styles.rightContainer}>
        {this.isRegistrationDateBeforeToday()!==-1 ?
          <div>
            <h3 style={styles.h3}>Forventet tilbage:</h3>
            <div className="waves-btn" style={styles.calenderContainer}>
              <DatepickerSmall
                defaultValue={initValue.date}
                onChange={this.onDateChange}
              />
            </div>
          </div>
        : null}
        </div>
      </div>
    );
  }
}

var styles = {
  header: {
    height: '60px',
    borderBottom: '1px solid ' + greyScaleColors.greyLight
  },
  heading:{
    lineHeight: '60px'
  },
  employeeName:{
    fontWeight: '500'
  },
  leftContainer: {
    float: 'left',
    width: '63.66666%',
    marginTop: '12px',
    borderRight: '1px solid ' + greyScaleColors.greyLight,
    height: '205px'
  },
  rightContainer: {
    float: 'right',
    width: '36.333333%',
    padding: '12px 0 0 12px'
  },
  absenceCode:{
    fontSize: '16px',
    height: '40px',
    margin: '0 8px 15px 0'
  },
  absenceCodeActive: {
    backgroundColor: semanticColors.infoLight
  },
  h3: {
    fontSize: '18px',
    marginBottom: '5px'
  },
  calenderContainer:{
    width: '200px',
    lineHeight: 'inherit',
    padding:'0px'
  }
}


  AbsenceStep.propTypes = {
    employee: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      hours: PropTypes.number,
      nightHours: PropTypes.number,
      sumHours: PropTypes.number,
      activities: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        hours: PropTypes.number.isRequired
      })).isRequired,
      absence: PropTypes.shape({
        date: PropTypes.object.isRequired,
        hours: PropTypes.number.isRequired,
        absenceCode: PropTypes.string
      }).isRequired
    }).isRequired,
    index: PropTypes.number.isRequired,
    handleConflict: PropTypes.func.isRequired,
    initValue: PropTypes.shape({
      date: PropTypes.object.isRequired,
      hours: PropTypes.number.isRequired,
      absenceCode: PropTypes.string
    }).isRequired,
    registrationDate: PropTypes.instanceOf(Date).isRequired
  };
export default Radium(AbsenceStep)


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/ConflictWizard/absenceStep.jsx